/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { ApikeysService } from './services/ApikeysService';
import { ApikeysProcessesService } from './services/ApikeysProcessesService';
import { AudienceSecurityGroupsService } from './services/AudienceSecurityGroupsService';
import { EnterpriseAuthnRulesService } from './services/EnterpriseAuthnRulesService';
import { HirePapiProcessesService } from './services/HirePapiProcessesService';
import { ImportProviderSettingsService } from './services/ImportProviderSettingsService';
import { JwksProcessesService } from './services/JwksProcessesService';
import { OktaProcessesService } from './services/OktaProcessesService';
import { OpensignupsService } from './services/OpensignupsService';
import { PapiProcessesService } from './services/PapiProcessesService';
import { SecurityAnalyticsProcessesService } from './services/SecurityAnalyticsProcessesService';
import { SecurityGroupsService } from './services/SecurityGroupsService';
import { SecurityGroupsProcessesService } from './services/SecurityGroupsProcessesService';
import { ServiceService } from './services/ServiceService';
import { SsoService } from './services/SsoService';
import { SsoProcessesService } from './services/SsoProcessesService';
import { SystemProcessesService } from './services/SystemProcessesService';
import { UsersService } from './services/UsersService';
import { UsersProcessesService } from './services/UsersProcessesService';
import { WorkerProcessesService } from './services/WorkerProcessesService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class AppClient {

  public readonly apikeys: ApikeysService;
  public readonly apikeysProcesses: ApikeysProcessesService;
  public readonly audienceSecurityGroups: AudienceSecurityGroupsService;
  public readonly enterpriseAuthnRules: EnterpriseAuthnRulesService;
  public readonly hirePapiProcesses: HirePapiProcessesService;
  public readonly importProviderSettings: ImportProviderSettingsService;
  public readonly jwksProcesses: JwksProcessesService;
  public readonly oktaProcesses: OktaProcessesService;
  public readonly opensignups: OpensignupsService;
  public readonly papiProcesses: PapiProcessesService;
  public readonly securityAnalyticsProcesses: SecurityAnalyticsProcessesService;
  public readonly securityGroups: SecurityGroupsService;
  public readonly securityGroupsProcesses: SecurityGroupsProcessesService;
  public readonly service: ServiceService;
  public readonly sso: SsoService;
  public readonly ssoProcesses: SsoProcessesService;
  public readonly systemProcesses: SystemProcessesService;
  public readonly users: UsersService;
  public readonly usersProcesses: UsersProcessesService;
  public readonly workerProcesses: WorkerProcessesService;

  public readonly request: BaseHttpRequest;

  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'http://localhost:8107',
      VERSION: config?.VERSION ?? '1.0.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });

    this.apikeys = new ApikeysService(this.request);
    this.apikeysProcesses = new ApikeysProcessesService(this.request);
    this.audienceSecurityGroups = new AudienceSecurityGroupsService(this.request);
    this.enterpriseAuthnRules = new EnterpriseAuthnRulesService(this.request);
    this.hirePapiProcesses = new HirePapiProcessesService(this.request);
    this.importProviderSettings = new ImportProviderSettingsService(this.request);
    this.jwksProcesses = new JwksProcessesService(this.request);
    this.oktaProcesses = new OktaProcessesService(this.request);
    this.opensignups = new OpensignupsService(this.request);
    this.papiProcesses = new PapiProcessesService(this.request);
    this.securityAnalyticsProcesses = new SecurityAnalyticsProcessesService(this.request);
    this.securityGroups = new SecurityGroupsService(this.request);
    this.securityGroupsProcesses = new SecurityGroupsProcessesService(this.request);
    this.service = new ServiceService(this.request);
    this.sso = new SsoService(this.request);
    this.ssoProcesses = new SsoProcessesService(this.request);
    this.systemProcesses = new SystemProcessesService(this.request);
    this.users = new UsersService(this.request);
    this.usersProcesses = new UsersProcessesService(this.request);
    this.workerProcesses = new WorkerProcessesService(this.request);
  }
}

